export const csvToJSON = (csv: string) => {
  var result = new Array<{ [key: string]: any }>();
  if (csv) {
    var lines = csv.split('\n');
    var headers;
    type ResultType = {
      [key: string]: any;
    };
    headers = lines[0].split(',');
    for (var i = 1; i < lines.length; i++) {
      var obj: ResultType = {};
      if (lines[i] === undefined || lines[i].trim() === '') {
        continue;
      }
      var words = lines[i].split(',');
      for (var j = 0; j < words.length; j++) {
        obj[headers[j]] = words[j];
      }
      result.push(obj);
    }
  }
  return result;
};
